export default __webpack_public_path__ + "static/media/bonus-01.8ce95472.png";